import { passThroughTranslation } from '@colonist/i18n';
/* eslint-disable boundaries/dependencies */ import { clientIntl } from '../../../../../code/client/shared/scripts/ClientI18n.ts';
export function getGlobeEmojiFexFromContinentCode(continentCode) {
    switch(continentCode){
        case 'NA':
        case 'SA':
            return '1f30e';
        case 'EU':
        case 'AF':
            return '1f30d';
        case 'AS':
        case 'OC':
            return '1f30f';
        default:
            return '1f30e';
    }
}
export function getFlagEmojiHexFromCountryCode(countryCode) {
    // https://dev.to/jorik/country-code-to-flag-emoji-a21
    const codePoints = countryCode.toUpperCase().split('').map((char)=>127397 + char.charCodeAt(0));
    return codePoints.map((i)=>i.toString(16)).join('-');
}
export function getCountryOrContinentImageLink(countryCode, continentCode, isUserOnDiscord) {
    const flagEmojiHexCode = typeof countryCode === 'string' ? getFlagEmojiHexFromCountryCode(countryCode) : getGlobeEmojiFexFromContinentCode(continentCode);
    if (isUserOnDiscord) return `/.proxy/jsdelivr/npm/twemoji@11.0.1/2/svg/${flagEmojiHexCode}.svg`;
    return `https://cdn.jsdelivr.net/npm/twemoji@11.0.1/2/svg/${flagEmojiHexCode}.svg`;
}
export function getTooltipText(countryCode, continentCode) {
    var _clientIntl_getCountryName;
    if (countryCode) return passThroughTranslation((_clientIntl_getCountryName = clientIntl.getCountryName(countryCode)) !== null && _clientIntl_getCountryName !== void 0 ? _clientIntl_getCountryName : '');
    if (continentCode) return {
        key: `strings:leaderboardPage.tabs.continents.${continentCode}`
    };
    return {
        key: 'strings:leaderboardPage.earth'
    };
}
